export class User {
  readonly id: string
  readonly email: string
  readonly name: string
  readonly isAdmin: boolean

  constructor (id: string, email: string, name: string, isAdmin: boolean) {
    this.id = id
    this.email = email
    this.name = name
    this.isAdmin = isAdmin
  }

  static fromJson (data: any): User {
    return new User(
      data.id,
      data.email,
      data.name,
      data.is_admin === true,
    )
  }
}
